import React from 'react';
import { connect } from 'react-redux';
import { Step } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import WizardStep from '@/components/wizard/WizardStep';
import { requestSteps } from '../constants';
import { allowedRequestStepIndexes, compactRequestStepIndexes } from '../helper';
import { newRequest, resolveRequestWorkflow } from '../state/state';

const RequestSteps = ({
  activeStepIndex,
  compact,
  goToStep,
  indexes,
  saveStatus,
  sections,
}) => {
  const activeStep = Object.values(requestSteps)[activeStepIndex].name;
  const steps = Object.values(requestSteps);
  const names = steps.map((step) => step.name);

  return (
    <Step.Group
      fluid={compact}
      size={compact ? 'mini' : 'tiny'}
      vertical={!compact}
      className="aridhia-request-steps"
    >
      {indexes.map((i) => (
        <WizardStep
          activeStep={activeStep}
          disabled={[states.PENDING, states.SUCCESS].includes(saveStatus)}
          title={steps[i].isSection ? sections[steps[i].name].label : undefined}
          entity="access"
          icon={steps[i].icon}
          index={i}
          key={`request_step${steps[i].name}`}
          onClick={goToStep}
          steps={names}
        />
      ))}
    </Step.Group>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions } },
  requests: { allowPmnTransfer, requests },
  workflows: { workflows },
}, ownProps) => {
  const { request, workflow } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const { activeStepIndex } = request.steps;
  const indexes = ownProps.compact
    ? compactRequestStepIndexes(request, permissions, allowPmnTransfer)
    : allowedRequestStepIndexes(request, permissions, allowPmnTransfer);

  return ({
    activeStepIndex,
    indexes,
    saveStatus: request.saveStatus,
    sections: workflow?.sections,
  });
};

export default connect(mapStateToProps)(RequestSteps);
